import React, { useEffect }  from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import { actions } from './WorkOrderReference/WorkOrderReference.redux';
import BooleanToggle from '../../components/BooleanToggle/BooleanToggle'
import { Select } from 'antd';

const SearchWorkOrders = () => {
	const dispatch         = useDispatch(),
		  navigate         = useHistory(),
		  params           = useParams(),
		  docNum           = params.docNum,
		  includeClosed    = useSelector(state => state.workOrderReference.includeClosed),
		  workOrderList    = useSelector(state => state.workOrderReference.workOrderList),
		  loadingWorkOrder = useSelector(state => state.workOrderReference.headerLoading);


	useEffect(() => {
		dispatch(actions.loadWODocNumList());
	}, [ dispatch, includeClosed ]);


	const onChange = (checked) => {
		dispatch(actions.setState({ includeClosed: checked }));
	};


	return (
		<>
			<div className='ts_margin_bottom'>
				<BooleanToggle
					onChange={onChange}
					inputProp={includeClosed}
					toggleLabel='Include closed & cancelled'
				/>
			</div>
			
			<Select
				className="ts_full_width ts_margin_bottom"
				size="large" 
				placeholder='Enter WO number'
				defaultValue={docNum ? docNum : ''}
				showSearch
				enterbutton="Search"
				loading={loadingWorkOrder}
				onChange={(value) => {
					navigate.push(`/work-orders/reference/${value}`);
				}}
				filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
			>
				<Select.Option key="work_order_search" value="">Enter WO# or part name to search</Select.Option>
				{
					workOrderList.map(order => {
						const serialNumber= order.SerialNumber ? ` - ${order.SerialNumber}` : '';
						const displayString = `${order.DocNum} - ${order.PartInfo} ${serialNumber}`;
						return <Select.Option key={order.DocNum} value={order.DocNum}>{displayString}</Select.Option>
				})
				}
			</Select>

		</>
	)

}

export default SearchWorkOrders;
